import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const goalsApiSlice = createApi({
  reducerPath: 'goalsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}`,
  }),
  tagTypes: ['SelectedGoals'],
  endpoints: (builder) => ({
    fetchSelectedGoals: builder.query({
      query: (token) => ({
        url: '/goals/selected',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      providesTags: [{ type: 'SelectedGoals', id: 'LIST' }],
    }),
    addSelectedGoal: builder.mutation({
      query: ({ token, goalId }) => ({
        url: `/goals/selected/${goalId}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        method: 'PUT',
      }),
      invalidatesTags: [{ type: 'SelectedGoals', id: 'LIST' }],
    }),
    deleteSelectedGoal: builder.mutation({
      query: ({ token, goalId }) => ({
        url: `/goals/selected/${goalId}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'SelectedGoals', id: 'LIST' }],
    }),
  }),
});

export const {
  useFetchSelectedGoalsQuery,
  useAddSelectedGoalMutation,
  useDeleteSelectedGoalMutation,
} = goalsApiSlice;
